export default "<div class=\"card\">\r\n    <div echarts id=\"pie\" class=\"chart-pie\" [options]=\"options\"></div>\r\n</div>"